<template>
  <Can action="view" subject="contract">
    <div data-component-group="contract-dialog" data-component="edit">
      <dialog-edit
        icon="receipt"
        :to="`/contracts/${activeContract?.id}`"
        :title="$t('edit_contract')"
        content-class="edit-contract-dialog"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-contract-edit
            :contract="activeContract"
            :is-loading="isEditingContract"
            :on-cancel="onCancel"
            :on-submit="$ability.can('update', 'contract') ? updateContract : undefined"
          />
        </template>
      </dialog-edit>
    </div>
  </Can>
</template>

<script>
  export default {
    emits: ['saved'],
    data() {
      return {
        isEditingContract: false,
      };
    },
    created() {
      if (!this.activeContract?.id) {
        this.$store.dispatch('contracts/getItem', { id: this.$route.params.id });
      }
    },
    computed: {
      activeContract() {
        return this.$store.getters['contracts/activeItem'];
      },
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'contracts', query: this.$route.query });
      },
      updateContract(contract) {
        const query = {
          id: this.activeContract.id,
          ...contract,
        };

        this.isEditingContract = true;

        return this.$store
          .dispatch('contracts/update', query)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: 'contracts', query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingContract = false;
          });
      },
    },
  };
</script>
